<template>
  <div class="card mb-3">
    <div class="card-header">
      Publication
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Publish Status</label>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="selected_publish_status" v-model="selected_publish_status" id="radio_yes" :value="1" @click="change_publish_status()">
          <label class="form-check-label" for="radio_yes">
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="selected_publish_status" v-model="selected_publish_status" id="radio_no" :value="0" @click="change_publish_status()">
          <label class="form-check-label" for="radio_no">
            No
          </label>
        </div>
      </div>
      <div class="form-group mb-0" v-show="selected_publish_status == 1">
        <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Publish on</label>
        <div class="form-check form-check-inline" :class="{'pl-5': index > 0}" v-for="(media_type, index) in arr_media_type" :key="index">
          <input class="form-check-input" type="radio" name="selected_type" v-model="selected_media_type" :id="'radio_'+media_type.data" :value="media_type.data" @click="change_media_type()">
          <label class="form-check-label" :for="'radio_'+media_type.data">
            {{ media_type.name }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data_media_type', 'data_is_publish'],
  data(){
    return{
      arr_media_type: [
        {
          "name": 'Web',
          "data": 'web',
        },
        {
          "name": 'Mobile',
          "data": 'mobile',
        },
        {
          "name": 'Both',
          "data": 'both',
        },
      ],
      selected_media_type: '',
      selected_publish_status: '',
    }
  },
  watch:{
    data_media_type(val){
      this.selected_media_type = val
      
    },
    data_is_publish(val){
      this.selected_publish_status = val
    },
  },
  methods:{
    change_media_type(){
      var context = this
      setTimeout(() => {
        context.$emit('on-media-type-changed', context.selected_media_type)
      },100)
    },
    change_publish_status(){
      var context = this
      setTimeout(() => {
        context.$emit('on-publish-status-changed', context.selected_publish_status)
      },100)
    },
  }
}
</script>